// src/config.js
// usa NODE_ENV perché CRA imposta automaticamente
const isDev = process.env.NODE_ENV === 'development';

export const API_URL = isDev
  ? process.env.REACT_APP_API_URL || 'http://localhost:5000'
  : process.env.REACT_APP_API_URL;

// Stripe Payment Links — configura in .env:
//   REACT_APP_STRIPE_PRO_URL=https://buy.stripe.com/...
//   REACT_APP_STRIPE_TEAM_URL=https://buy.stripe.com/...
export const STRIPE_PRO_URL  = process.env.REACT_APP_STRIPE_PRO_URL  || null;
export const STRIPE_TEAM_URL = process.env.REACT_APP_STRIPE_TEAM_URL || null;

// Vendita degli abbonamenti sospesa dal 2026-10-16 (partita IVA cessata).
// A false il modale dei piani mostra un avviso al posto del bottone d'acquisto;
// il Payment Link resta valido finché non lo si disattiva nella dashboard di Stripe.
export const PURCHASES_ENABLED = false;
export const CONTACT_EMAIL = 'info@traduttorerefertimedici.it';
